import React from 'react'
import "./TermsCondition.css"
import { Link, useNavigate } from 'react-router-dom';
function RefundPolicy() {
    const navigate = useNavigate();
    const previouseScreen = () => {
        navigate(-1);
    }
    return (
        <div class="container-fluid  global_container BathHeader">
            <div className='p-3'>


                <div className="row mb-2">
                    <div className="col-md-6 col-12">
                        <h2 className="TitleHeader"> Refund Policy </h2>
                    </div>
                    <div className="col-md-6 col-12 ListBtn">
                        <ul class="List-Button">
                            <li class="ListBtnItems">
                                <Link
                                    to={"javascript:void(0)"}
                                    onClick={previouseScreen}
                                    className="secondaryButton "
                                    variant="secondary"
                                >
                                    Back
                                </Link>
                            </li>


                        </ul>
                    </div>
                </div>
                <div class="">
                    <p>
                      At AIASA Book Publications, we value your trust and are committed to ensuring a smooth shopping experience. Please read the following policy carefully to understand our process regarding shipping, returns, refunds, and cancellations.
                    </p>
                    <p>
                        These terms apply to this website, all products and services as offered by AIASA BOOK
                        PUBLICATIONS. Users of this website are requested to please read these Terms carefully before
                        using this website, which is operated and owned by AIASA BOOK PUBLICATIONS.
                        Your access to and use of this website service is conditioned on your acceptance of and compliance
                        with these Terms. These terms apply to all visitors, users and others who access or use the services
                        in this website.

                    </p>
                    <p>
                        By registering on this website or by subscribing to a service provided in this website and by
                        providing your contact details, viz Name, Address, Adhaar number, telephone number, email, mobile
                        number, shipping address, etc., User hereby give their consent, for the purpose of receiving
                        information about products and services offered by AIASA BOOK PUBLICATIONS. User also hereby
                        give their consent that AIASA BOOK PUBLICATIONS may contact you in future to provide
                        information regarding its products and services by using the information that they have provide to
                        AIASA BOOK PUBLICATIONS.
                    </p>

                    <a href='#' className="subTitleHeader">USER PERSONAL IDENTIFICATION INFORMATION</a>
                    <p className='pt-3'>
                        AIASA BOOK PUBLICATIONS is committed to safe guard personal identification information
                        of the users such as users name, address, telephone, email, mobile number, shipping address,
                        personal information etc.,. Such information, which has been shared in our website by the users, will
                        be stored in secure manner and will be used by AIASA BOOK PUBLICATIONS only for academic
                        purposes. AIASA BOOK PUBLICATIONS has adequate security measures to protect against
                        unauthorized access, alteration, disclosure or destruction of users personal information, username,
                        password, transaction information and data stored on AIASA BOOK PUBLICATIONS website.
                        AIASA BOOK PUBLICATIONS will not share users’ personal identification information with any third
                        party for any reason whatsoever. AIASA BOOK PUBLICATIONS assures that the information shared
                        by users will be secure and will be treated as privileged information.
                    </p>

                    <a href='#' className="subTitleHeader">PURCHASED BOOK FEE - NON REFUNDABLE</a>

                    <p className='pt-3'>
                        Candidates must understand the rules pertaining to payment of book fee, before purchasing
                        to any book offered by AIASA BOOK PUBLICATIONS. The fees and other dues, once paid, under
                        no circumstances is refundable, adjustable or transferable. AIASA BOOK PUBLICATIONS shall not
                        entertain any kind of refund once a candidate has been purchased the any kind of quantity of
                        Books/Magazine/e-book etc., No disputes regarding refunds will be entertained by AIASA BOOK
                        PUBLICATIONS once the payments are paid.<span style={{ color: "red" }}> These terms and conditions shall be governed by and
                            constructed according to the laws in force in India. The Candidates and other users of this website
                            shall hereby submit to the jurisdiction of the courts situated at Chennai for the purpose of actions
                            and proceedings arising out of the terms and conditions. The courts at Chennai shall have the sole
                            jurisdiction to hear and decide such actions and proceedings.  </span >
                    </p>
                    <a href='#' className="subTitleHeader">COURIER CHARGES</a>
                    <p className='pt-3'>
                        The Courier charges collected by the AIASA Book Publication based on the wait of the book
                        and the charges will be applicable each item of the goods / Articles / Books / Study Material offered
                        by the AIASA Book Publications. The charges may be vary and differ whenever the Courier charges
                        Rates are revised by the delivery authority.
                    </p>
                    <a href='#' className="subTitleHeader">REWARD POINTS </a>
                    <p className='pt-3'>
                        Reward points is a promotional point. The reward points is completely discretionary of the
                        AIASA Book Publications authority and no user can claim as a right by using the enforcing law. The
                        announced reward points can cancel by the authority at any time. The user may use their reward
                        points, which was earned by them within the stipulated period announced by the AIASA Book
                        Publications. If the reward points once lapsed / cancelled by the AIASA Book Publications no user
                        can claim.
                    </p>

                    <a href='#' className="subTitleHeader">DELIVERY MODE
                    </a>
                    <p className='pt-3'>
                        The AIASA Book Publications offered the two types of delivery mode. One is Courier Delivery
                        and another one is Branch pickup. The user can choose either any one of the options and collect
                        the book accordingly. If the user choose the courier delivery and try to collect the book through
                        branch pickup at anyway the courier charges cannot be refund at any time. If the user who has choose, the branch pickup can raised a request at branch to send a
                        courier delivery by paying the additional cost of courier charges. In the mode of delivery any
                        discrepancies and difficulties or any delayed faced by the user, the user should directly contact the
                        courier authority in such cases AIASA BOOK PUBLICATIONS is no way responsible for the delaines
                        and difficulties.

                    </p>



                    <a href='#' className="subTitleHeader">CANCELLATION OF ORDER</a>
                    <p className='pt-3'>
                        TheBooks/Articles offered byAIASA BOOK PUBLICATIONS is tailored to train the candidates
                        within a specific period and within stipulated time span, in any event if the candidate cancelled or
                        leaves in the midway of the order whatsoever, AIASA BOOK PUBLICATIONS shall not have any
                        obligation to refund, adjust or transfer the payment paid by the Purchaser/User. Purchased user may
                        apply for cancellation of his\her order at any time during the midway of the item, in such event also
                        AIASA BOOK PUBLICATIONS shall not have any obligation to refund the payment paid by the
                        Purchaser/User.

                    </p>
                  

               
                </div>
            </div>
        </div>
    )
}

export default RefundPolicy;